export const isValidDate = (dateString) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  return !Number.isNaN(date.getTime());
};
export const isEmptyOrNull = (value) => !value?.toString().trim();
export const isEmptyOrNullOrZero = (value) => isEmptyOrNull(value) || value.toString().trim() === '0';
export const isInvalidPrice = (value) => isEmptyOrNull(value) || Number.isNaN(Number(value?.toString().trim()));
export const checkFieldsForEmptyValues = (obj, fields) =>
  fields.some((field) => {
    if (field === 'price') return isInvalidPrice(obj[field]);
    if (field === 'vendorItemId') return isEmptyOrNull(obj[field]);
    return isEmptyOrNullOrZero(obj[field]);
  });
